import * as Common from '@/agiles/common';

// JSONをJavaScriptの型のバインドします。
export class ModelBinder {
  private ctor: new () => Common.ObjectBase;
  private isCollection: boolean;
  constructor(ctor: new () => Common.ObjectBase, isCollection=false) {
    this.ctor = ctor;
    this.isCollection = isCollection;
  }
  public createInstance(): any {
    return new this.ctor();
  }

 
  public loadSingleInstance(data: any, hash: WeakMap<any,any>): any {
    // 階層化したオブジェクトのコピーは要検討
    const target = this.createInstance();    
    hash.set(data,target); //登録する
    // tslint:disable-next-line:forin
    target.isLoaded = false;
    for (const prop in data) {
      if (target.binders[prop] != null && prop != '$id') {
        if (Array.isArray(target[prop])) {
          // コレクションロード
          for (const item of data[prop]) {
            target[prop].push(target.binders[prop].loadInstance(item,hash));
          }
        } else {
          //単体オブジェクトロード
          target[prop] = target.binders[prop].loadInstance(data[prop],hash);
        }
      } else {
        //値のロード
        target[prop] = data[prop];
      }
    }
     target.isLoaded = true;
    return target;
  }

  public loadInstance(data: any, hash: WeakMap<any,any> =null) :any{

    if (hash==null) hash = new WeakMap<any,any>();
    if (hash.has(data)){
      return hash.get(data);
    }
    if (data == null) {
      return null;
    } else if (this.isCollection){
      const result = new Array(0);
      for (const obj of data) {
        result.push(this.loadSingleInstance(obj, hash));
      }
      return result;
    } else {
      return this.loadSingleInstance(data,hash);
    }
  }

  public loadInstances(data: object[]): any {
    const result = new Array(0);
    for (const obj of data) {
      result.push(this.loadInstance(obj));
    }
    return result;
  }
}

/**genericコンストラクタを受け取るモデルをバインドします */
export class GenericModelBinder extends ModelBinder {
  constructor(ctor :new(generic: new()=>Common.ObjectBase)=>Common.ObjectBase, generic:new()=>Common.ObjectBase) {
    super(null);
    this.ctor2 = () => new ctor(generic);;
  }
  private ctor2: ()=> Common.ObjectBase;
  public createInstance(): any {
    return this.ctor2();
  }
}
